<template>
  <div>
    <div class="web-box" style="padding-top: 40px">
      <p class="callus-title">联系我们</p>
      <div class="color-line"></div>
      <p class="callus-subtitle">留下您的联系方式，我们将快速与您联系</p>
      <div class="card">
        <div class="form-line">
          <span class="icon">&#xe8f1;</span>
          <input v-model="form.company" placeholder="公司名称" />
        </div>
        <p><span v-if="rules.company">请输入公司名称</span>&emsp;</p>
        <div class="form-line">
          <span class="icon">&#xe768;</span>
          <input v-model="form.city" placeholder="所在城市" />
        </div>
        <p><span v-if="rules.city">请输入所在城市</span>&emsp;</p>
        <div class="form-line">
          <span class="icon">&#xe66f;</span>
          <input
            v-model="form.name"
            @input="Input('name')"
            placeholder="姓名"
          />
        </div>
        <p><span v-if="rules.name">请输入你的姓名</span>&emsp;</p>
        <div class="form-line">
          <span class="icon">&#xe61a;</span>
          <input
            v-model="form.telephone"
            @input="Input('telephone')"
            placeholder="手机号码"
          />
        </div>
        <p><span v-if="rules.telephone">请输入手机号码</span>&emsp;</p>
        <div class="form-line">
          <span class="icon">&#xe684;</span>
          <input
            v-model="form.mailbox"
            @input="Input('mailbox')"
            placeholder="邮箱"
          />
        </div>
        <p><span v-if="rules.mailbox">请输入邮箱</span>&emsp;</p>
        <div class="button" @click="submit">
          <span v-if="loading"> <a-icon type="loading" />&ensp; </span>预约咨询
        </div>
      </div>
    </div>
    <div class="wrap">
      <div class="web-box" style="padding: 40px 20px">
        <a-row>
          <a-col :xs="12" :sm="8">
            <p class="call-us">
              <b>关于我们</b>
              <br />公司简介 <br />隐私协议 <br />信息源安全承诺书
              <br />免责声明
            </p>
          </a-col>
          <a-col :xs="12" :sm="8">
            <p class="call-us">
              <b>友情链接</b>
              <br />
              <a href="http://www.reyun.com/">热云监控</a>
              <br />
              <a href="https://www.talkingdata.com/">Talkingdata</a>
              <br />
              <a href="https://www.appsflyer.com/">Appflyer</a>
            </p>
          </a-col>
          <a-col :xs="24" :sm="8">
            <p class="call-us">
              <b>我们的联系方式</b>
              <br />厦门偕行星联管理咨询有限公司 <br />邮编：361000
              <br />电子邮箱：cai20091@qq.com <br />电话：0592-5197379
              <br />地址：厦门市思明区宜兰路5号2403室之一
            </p>
          </a-col>
        </a-row>
      </div>
      <div class="bottom">
        <!-- <img src="../assets/jinghui.png" /> -->
        <p>
          <a href="https://beian.miit.gov.cn/"
            >闽ICP备2023001187号-1 Copyright 2023 © VEDA All Reserved</a
          >
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import qs from 'qs'
export default {
  data () {
    // const href = window.location.href;
    // console.log(href);
    return {
      form: {
        company: '',
        city: '',
        name: '',
        telephone: '',
        mailbox: ''
      },
      rules: {
        company: '',
        city: '',
        name: '',
        telephone: '',
        mailbox: ''
      },
      loading: false
    }
  },
  methods: {
    Input (key) {
      this.rules[key] = false
    },
    submit () {
      if (this.loading) return
      if (!this.form.name) {
        this.rules.name = true
        return false
      }
      if (!this.form.telephone) {
        this.rules.telephone = true
        return false
      }
      if (!this.form.mailbox) {
        this.rules.mailbox = true
        return false
      }
      this.loading = true
      //   this.$axios.setHeader(
      //     'Content-Type',
      //     'application/x-www-form-urlencoded',
      //     ['post']
      //   )
      this.$jsonp(
        `https://h5.vedamobi.com/index.php/api/api/register?${qs.stringify(
          this.form
        )}`,
        {},
        (error, data) => {
          if (data.code === 200) {
            this.$message.info('提交成功！')
          } else {
            this.$message.error(`${data.msg}`)
          }
          this.loading = false
        }
      )
      //   this.$axios.defaults.headers.post['Content-Type'] =
      //     'application/x-www-form-urlencoded'
      //   const params = new URLSearchParams()
      //   params.append('name', 12323)
      //   const data = await this.$axios({
      //     method: 'post',
      //     url: '/api/api/register',
      //     data: qs.stringify(this.form)
      //   })
    }
  }
}
</script>
<style lang="scss" scoped>
.wrap {
  margin-top: 20px;
  width: 100%;
  background: #000000;
  .web-box2 {
    width: 100%;
    max-width: 1366px;

    padding: 20px 30px;
    margin: 0 auto;
  }
  .call-us {
    color: #fff;
    line-height: 60px;
    font-size: 20px;
    margin-top: 60px;
    a {
      color: #fff;
      &:hover {
        color: #0f8cf0;
      }
    }
  }
}
.card {
  margin: 0 auto;
  width: 100%;
  max-width: 560px;
  background-color: #fff;
  border-radius: 2px;
  padding: 40px 25px;
  p {
    font-size: 14px;
    color: red;
    margin: 5px 0 10px;
  }
}
.button {
  width: 100%;
  height: 56px;
  color: #fff;
  border-radius: 3px;
  line-height: 56px;
  font-size: 18px;
  text-align: center;
  background-color: #4d73ff;
  cursor: pointer;
}
.bottom {
  width: 100%;
  padding: 0 20px;
  p {
    border-top: 1px solid rgb(184, 184, 184);
    text-align: center;
    color: #fff;
    font-size: 14px;
    margin: 0;
    padding: 20px 0;
    vertical-align: middle;
  }
  img {
    width: 16px;
    height: 16px;
    vertical-align: middle;
  }
}
.form-line {
  height: 46px;
  padding: 0 16px;
  background-color: #fff;
  border: 1px solid #eee;
  border-radius: 3px;
  overflow: hidden;
  .icon {
    font-family: 'iconFont';
    font-size: 20px;
    color: #b3b3b3;
    vertical-align: middle;
    line-height: 46px;
  }
  input {
    width: calc(100% - 40px);
    border-style: none;
    outline: none;
    border-width: 0;
    line-height: 44px;
    vertical-align: middle;
    margin-left: 10px;
  }
}
.color-line {
  margin: 20px auto;
  width: 85px;
  height: 2px;
  background-image: linear-gradient(to right, #45b3fc, #28f7ff);
}
.callus-title {
  text-align: center;
  color: #333;
  font-size: 36px;
  margin: 20px 0;
}
.callus-subtitle {
  font-size: 18px;
  text-align: center;
}
</style>
